export default __webpack_public_path__ + "c62b6f1c8387ec36e29e119d683d34b7.jpg";